import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.682 10.659 3.964 29.329a9 9 0 0 1-1.282-1.386L20.972.276c1.888.207 3.557.532 4.719.987 4.447 1.728 5.476 6.646 5.476 6.646.22.913.388 1.834.515 2.75",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M21.443.33 2.716 27.99a10.8 10.8 0 0 1-1.332-2.316l5.38-24.591C8.92.382 12.489.032 16 0c1.87.017 3.758.124 5.443.33",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M10.901.287 1.845 26.633c-.74-1.372-.979-2.509-.979-2.509-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C7.46.803 9.071.491 10.902.287",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m5.377 30.32 26.157-8.174q-.166.989-.4 1.978s-1.03 4.918-5.477 6.646C23.567 31.6 19.75 31.967 16 32c-3.75-.034-7.567-.432-9.658-1.23a8 8 0 0 1-.965-.45",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSyc = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSyc_default = SvgFlagSyc;

export { FlagSyc_default as default };
